import React from 'react';
import { shopContent } from '../../../../constants/copyright';
import CustomButton from '../../../features/customButton/ui/main/CustomButton';
import classNames from 'classnames';
const { itemButton } = shopContent;

const ShopItem = React.forwardRef(function ShopItem({ item, product, status, onClick, index }, ref) {
  return (
    <div className={'shop__item'} onClick={onClick}>
      <div className={'shop__item-image'}>
        <img src={item.preview_image} alt={`item-img-${index}`} />
      </div>
      <CustomButton
        text={itemButton.text[status]}
        icon={itemButton.icon[status]}
        className={classNames('shop__item-button button_shop', {
          'shop__item-button_yellow': { absent: true }[status],
        })}
      />
    </div>
  );
});

export default ShopItem;
ShopItem.propTypes = {};
